/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018, 2022
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/glass/controllers/ShareMenuController',['underscore', '../../lib/@waca/baglass/js/baglass/app/plugins/MenuActionInterface', '../../api/sharing/ShareableItems', '../../lib/@waca/baglass/js/baglass/utils/Utils', '../../utils/AssetTypeUtil', '../utils/GlassUtil', '../utils/ReactBridge', '../../nls/StringResources'], function (_, MenuActionInterface, ShareableItems, Utils, AssetTypeUtil, GlassUtil, ReactBridge, StringResources) {
	'use strict';

	var perspective = GlassUtil.perspective,
	    featuresForContextual = GlassUtil.featuresForContextual;


	var GLASS_SHARED_ID = perspective.contextual.LINK;
	var GLASS_EMBED_ID = perspective.contextual.EMBED;

	function getShareFeatures(context) {
		var share = context.target.plugin.itemSpec.items.find(function (e) {
			return e.id === 'com.ibm.ca.collaboration.shareContextual';
		});

		return featuresForContextual(share.items || []);
	}

	var ShareMenuController = MenuActionInterface.extend({

		init: function init() {
			ShareMenuController.inherited('init', this, arguments);
			this.shareableItems = new ShareableItems();
		},

		onOpen: function onOpen(context) {
			var _this = this;

			if (this._actionController) {
				return;
			}
			return Promise.resolve().then(function () {
				var selection = context.target && context.target.plugin && context.target.plugin.activeObject && context.target.plugin.activeObject.aSelectedContext;

				return Utils.getSharedResourceActionController(context.glassContext, _this._getResourceType(context), selection).then(function (controller) {
					_this._actionController = controller;
				});
			});
		},

		getItemOptions: function getItemOptions(context) {
			return _.find(context.target.plugin.itemSpec.items, function (item) {
				return item.id === context.target.itemId;
			}).options;
		},

		/**
   * It is a callback which is called when an item is selected.
   * @param context
   * @return {Promise}
   */
		onSelectItem: function onSelectItem(context) {
			return this.execute(context);
		},

		/**
   * Called when the share button under asset details is selected.
   * @param context
   * @return {Promise}
   */
		execute: function execute(context) {
			var _this2 = this;

			this.shareableItems.setLogger(context);

			var selectedContext = context.target.activeObject.aSelectedContext[0];

			return this.shareableItems.getLink(context.glassContext, context.target).then(function (link) {
				var bridge = new ReactBridge({
					glassContext: context.glassContext,
					embedVisible: _this2._checkItemVisible(context, GLASS_EMBED_ID),
					features: getShareFeatures(context),
					selectedAsset: {
						link: link,
						type: {
							assetType: _this2.getAssetType(selectedContext),
							assetTitle: selectedContext.defaultName
						},
						object: {
							objectType: _this2.getObjectType(selectedContext),
							objectId: selectedContext.id
						}
					},
					extra: _this2.getItemOptions(context)
				});
				return bridge.execute();
			}).catch(function (err) {
				context.glassContext.showToast(StringResources.get('error_unknown', { error: err.message }), { type: 'error' });
				var logger = context.glassContext.getCoreSvc('.Logger');
				logger.error(err);
			});
		},

		getAssetType: function getAssetType(selectedContext) {
			var assetType = '';
			if (selectedContext.tags && selectedContext.tags.length > 0) {
				assetType = AssetTypeUtil.getLocalizedType(selectedContext.tags[0]) || selectedContext.tags[0];
			} else if (selectedContext.type === 'exploration' && selectedContext.defaultScreenTip == 'story') {
				assetType = AssetTypeUtil.getLocalizedType('story');
			} else if (selectedContext.type === 'dashboard') {
				// dashboard CM Type -> "Workspace" 
				assetType = AssetTypeUtil.getLocalizedType('workspace');
			} else {
				assetType = AssetTypeUtil.getLocalizedType(selectedContext.type) || '';
			}
			return assetType;
		},

		/**
   * Returns the asset type as far as instrumentation is concerned.
   * @param selectectContext the context of the selected item.
   * @return the object type for instrumentation purposes.
   */
		getObjectType: function getObjectType(selectedContext) {
			return selectedContext.tags && selectedContext.tags.length > 0 ? selectedContext.tags[0] : selectedContext.type;
		},

		/**
   * It is a callback that is called to check if an item is visible
   * @param context
   * @return true if the item is visible, false otherwise
   */
		isItemVisible: function isItemVisible(context) {
			return getShareFeatures(context).length && this._checkItemVisible(context, GLASS_SHARED_ID);
		},

		_checkItemVisible: function _checkItemVisible(context, glassItemId) {
			var itemId = context.target.itemId;
			context.target.itemId = glassItemId;

			var visible = false;
			var singleSelection = _.isUndefined(context.options) || _.isArray(context.options) && context.options.length === 1;
			if (singleSelection && !_.isUndefined(this._actionController)) {
				visible = !_.isFunction(this._actionController.isVisible) || this._actionController.isVisible(context) === true;
			}

			context.target.itemId = itemId;
			return visible;
		},

		_getResourceType: function _getResourceType(context) {
			var type = void 0;
			try {
				type = context.target.plugin.options[0].type;
			} catch (e) {
				type = context.glassContext.currentAppView.getType();
			}
			return type;
		}
	});

	return ShareMenuController;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

